<style>
    .terms {
        max-height: 200px;
        overflow: scroll;
        padding: 10px;
        margin-top: 10px;
        border: 1px solid #efefef;
    }
</style>

<template>
    <div class="animated fadeIn">

        <Request
                ref="request"
                root="/shop/checkout"
                method="GET"
                :onRequestSuccess="onRequestSuccess">
            <slot slot="body">

                <div v-if="dataProcessCompleted===false">
                    <CForm
                            ref="form"
                            @onSubmit="process"
                            v-if="dataFormStructure.rows !== undefined"
                            :options="{
                            submit: {
                                text: 'Confirmer l\'achat',
                                variant: 'success'
                            }
                        }"
                            :structure="dataFormStructure">
                        <template v-for="row, rowIndex in dataFormStructure.rows">
                            <template v-for="col, colIndex in row.cols">
                                <template :form="form" v-if="col.cards !== undefined" :cards="col.cards">
                                    <slot v-for="card in col.cards" v-if="card.key !== ''" :slot="card.key">
                                        <slot :name="card.key"></slot>
                                    </slot>
                                </template>
                            </template>
                        </template>
                        <slot slot="summary">
                            <div v-if="dataProducts.length > 0">
                                <Cart ref="cart" :readOnly="true" v-model="dataProducts"></Cart>
                                <InputCC
                                        ref="CC"
                                        v-if="dataTotal>0"
                                        :onTokenizationSuccess="onTokenizationSuccess"
                                        :onTokenizationError="onTokenizationError"
                                        v-model="dataPayment.CC"></InputCC>
                            </div>
                            <div v-if="dataProducts.length === 0">
                                <b-alert show variant="warning">
                                    {{Core.Definition.getDefinition("Votre panier est vide!")}}
                                </b-alert>
                            </div>
                            <div v-if="dataTermsRefundPolicy !== ''">
                                <strong>{{Core.Definition.getDefinition("Termes et conditions")}}</strong>
                                <p class="terms" v-html="dataTermsRefundPolicy"></p>
                                <InputCheckbox
                                        :required="true"
                                        :label="Core.Definition.getDefinition('J\'ai lu et j\'accepte les termes et conditions')"
                                        v-model="dataAcceptTerm"></InputCheckbox>
                            </div>
                        </slot>
                        <slot slot="afterFormButtons">
                            <slot name="afterFormButtons"></slot>
                        </slot>
                        <slot slot="afterForm">
                            <b-alert variant="danger" :show="dataAcceptTermAlert">
                                {{Core.Definition.getDefinition('Vous devez compléter les informations de paiement puis vous devez accepter les termes et les conditions.')}}
                            </b-alert>
                        </slot>
                    </CForm>
                </div>

            </slot>
        </Request>


    </div>
</template>

<script>
    import Request from '../../../components/Request'
    import CForm from '../../../components/CForm'
    import Cart from '../../../components/Cart'
    import InputCC from '../../../components/InputCC'
    import InputCheckbox from '../../../components/InputCheckbox'
    export default {
        name: 'ShopCheckout',
        components: {
            Cart,
            InputCC,
            Request,
            CForm,
            InputCheckbox
        },
        props: {
            paymentSuccessRedirectType: {
                type: String,
                default: 'router'
            },
            paymentSuccessRedirectUrl: {
                type: String,
                default: ''
            },
            branchId: {
                type: String | Number,
                default: ''
            }
        },
        mounted() {
            Core.Session.Cart.retrieve()
            this.dataProducts = Core.Session.Cart.products

            this.$nextTick(function() {
                this.dataTotal = this.$refs.cart.total
            })

            this.init()
        },
        data: function () {
            return {
                dataTermsRefundPolicy: '',
                Core: window.Core,
                dataProducts: [],
                dataTotal: 0,
                dataAcceptTerm: false,
                dataAcceptTermAlert: false,
                dataProcessCompleted: false,
                dataPayment: {
                    date: '',
                    method: Core.Value.selectValue(Core.Payment.methodCC, Core.Payment.methodOptions()),
                    status: null,
                    referenceNumber: '',
                    amount: '0',
                    saveCC: false,
                    CC: {
                        holderName: '',
                        number: '',
                        expMonth: '',
                        expYear: '',
                        CVD: '',
                        token: ''
                    }
                },
                dataFormStructure: {
                    rows: [
                        {
                            cols: [
                                {
                                    class: 'card-columns',
                                    cards: [
                                        {
                                            caption: Core.Definition.getDefinition('Informations de facturation'),
                                            rows: [
                                                {
                                                    cols: [
                                                        {
                                                            fields: [
                                                                {
                                                                    id: 'firstname'
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            fields: [
                                                                {
                                                                    id: 'lastname'
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            fields: [
                                                                {
                                                                    id: 'email'
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            fields: [
                                                                {
                                                                    id: 'phone'
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            fields: [
                                                                {
                                                                    id: 'billingAddress'
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    cols: [
                                                        {
                                                            fields: [
                                                                {
                                                                    id: 'billingCity'
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            fields: [
                                                                {
                                                                    id: 'billingZipcode'
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            caption: Core.Definition.getDefinition('Sommaire'),
                                            key: 'summary'
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    fields: [
                        {
                            id: 'firstname',
                            type: 'text',
                            label: Core.Definition.getDefinition('Prénom'),
                            required: true,
                            value: ''
                        },
                        {
                            id: 'lastname',
                            type: 'text',
                            required: true,
                            label: Core.Definition.getDefinition('Nom de famille'),
                            value: ''
                        },
                        {
                            id: 'email',
                            type: 'email',
                            required: true,
                            label: Core.Definition.getDefinition('Courriel'),
                            value: ''
                        },
                        {
                            id: 'phone',
                            type: 'phone',
                            required: true,
                            label: Core.Definition.getDefinition('Téléphone'),
                            value: ''
                        },
                        {
                            id: 'billingAddress',
                            type: 'text',
                            required: true,
                            label: Core.Definition.getDefinition('Adresse'),
                        },
                        {
                            id: 'billingCity',
                            type: 'text',
                            required: true,
                            label: Core.Definition.getDefinition('Ville'),
                        },
                        {
                            id: 'billingZipcode',
                            type: 'text',
                            required: true,
                            label: Core.Definition.getDefinition('Code Postal'),
                        }
                    ]
                }
            }
        },
        methods: {
            init() {
                this.$refs.request.clearArgs()
                this.$refs.request.setMethod('GET')
                this.$refs.request.request()
            },
            process() {
                this.dataAcceptTermAlert = false
                if (this.$refs.form.validate()) {

                    if (this.$refs.cart.total > 0) {
                        if (this.dataPayment.CC.number !== ''
                            && this.dataPayment.CC.holderName !== ''
                            && this.dataPayment.CC.CVD !== ''
                            && this.dataPayment.CC.expYear !== ''
                            && this.dataPayment.CC.expMonth !== '') {
                            if (this.dataTermsRefundPolicy === '' || this.dataAcceptTerm === true) {
                                this.$refs.form.securityBlock = true
                                this.$refs.CC.getToken()
                            } else {
                                this.dataAcceptTermAlert = true
                            }

                        } else {
                            this.dataAcceptTermAlert = true
                        }
                    } else {
                        if (this.dataTermsRefundPolicy === '' || this.dataAcceptTerm === true) {
                            this.$refs.form.securityBlock = true
                            this.onTokenizationSuccess('FREE')
                        } else {
                            this.dataAcceptTermAlert = true
                        }
                    }
                }
            },
            onRequestSuccess(data) {
                if (data.form !== undefined) {
                    for(let key in data.form) {
                        let value = data.form[key]
                        let field = Core.Array.findByKey(this.dataFormStructure.fields, 'id', key)
                        if (field.type !== undefined) {
                            let selectOptions = []
                            if (data.selectOptions !== undefined) {
                                if (data.selectOptions[key] !== undefined) {
                                    selectOptions = data.selectOptions[key]
                                }
                            }
                            value = Core.Value.encode(value, field.type, selectOptions)
                            this.$refs.form.setValue(key, value)
                        }
                    }
                }
                if (data.referenceNumber !== undefined||data.purchases !== undefined){
                    let paymentSuccessRedirectUrl = ''
                    if (this.paymentSuccessRedirectUrl !== '') {
                        paymentSuccessRedirectUrl = this.paymentSuccessRedirectUrl
                    }

                    switch(this.paymentSuccessRedirectType) {
                        case 'router':
                            if (paymentSuccessRedirectUrl==='') {
                                paymentSuccessRedirectUrl = Core.Definition.getDefinition('/commerce/boutique/merci')
                            }
                            this.$router.push(paymentSuccessRedirectUrl)
                            break
                        case 'url':
                            window.location.href = paymentSuccessRedirectUrl
                            break
                    }

                    Core.Session.Cart.empty()
                    this.dataProcessCompleted = true
                }

                if (data.termsRefundPolicy) {
                    this.dataTermsRefundPolicy = data.termsRefundPolicy
                }

                this.$refs.form.securityBlock = false
            },
            onTokenizationSuccess(token, form) {

                let payment = {
                    token: token,
                    amount: this.dataPayment.amount,
                    date: this.dataPayment.date,
                    CC: {
                        last4: this.dataPayment.CC.number.slice(-4),
                        expMonth: this.dataPayment.CC.expMonth,
                        expYear: this.dataPayment.CC.expYear,
                        saveCC: this.dataPayment.saveCC
                    }
                }

                this.$refs.request.clearArgs()
                this.$refs.request.setMethod('POST')

                for(let key in this.$refs.form.form) {
                    let field = Core.Array.findByKey(this.dataFormStructure.fields, 'id', key)
                    let value = this.$refs.form.form[key]
                    this.$refs.request.addArg(key, value, field.type)
                }

                let cartOptions = Core.Session.getValue('cartOptions')

                if(cartOptions&&cartOptions!==undefined&&cartOptions!==null) {
                    cartOptions = JSON.parse(cartOptions)
                    cartOptions = Core.Value.decode(cartOptions, Core.Value.typeCartOptions)
                }

                let products = []
                for(let product in this.dataProducts) {
                    product = this.dataProducts[product]
                    let productCartOptions = []
                    if (cartOptions!==null&&cartOptions!==undefined) {
                        if (cartOptions.products !== undefined) {
                            for(let cartOptionProduct in cartOptions.products) {
                                cartOptionProduct = cartOptions.products[cartOptionProduct]
                                if (cartOptionProduct.id == product.id) {
                                    productCartOptions.push(cartOptionProduct)
                                }
                            }
                        }
                    }

                    let promoCode = false
                    if (product.data !== undefined && product.data.promoCode !== undefined) {
                        promoCode = product.data.promoCode.code
                    }

                    products.push({
                        id: product.id,
                        quantity: product.quantity,
                        cartOptions: productCartOptions,
                        promoCode: promoCode
                    })
                }

                if (cartOptions!==null&&cartOptions!==undefined&&cartOptions.forms !== undefined) {
                    this.$refs.request.addArg('forms', JSON.stringify(cartOptions.forms))
                }

                this.$refs.request.addArg('products', JSON.stringify(products))
                this.$refs.request.addArg('payment', JSON.stringify(payment))

                this.$refs.request.request()
            },
            onTokenizationError(form) {
            }
        }
    }
</script>
